<template>
  <div id="my-stats-page" class="admin-page">
    <div class="admin-page-header">
      <h1>My Progress</h1>
      <StatsViewToggle v-if="sessions.length" v-model="view" />
    </div>

    <div v-if="loading" class="admin-card">
      <div class="admin-state">
        <i class="fas fa-circle-notch fa-spin" style="margin-right:0.5rem"></i>
        Loading your statistics…
      </div>
    </div>

    <div v-else-if="!userId" class="admin-card">
      <div class="admin-state admin-state--rich">
        <i class="fas fa-user-lock"></i>
        <h3>Sign in to track your progress</h3>
        <p>
          Statistics are only recorded for players signed in with an email address.
          Games played with a game code are not saved.
        </p>
        <router-link to="/game-login" class="admin-btn admin-btn--primary">
          Go to sign in
        </router-link>
      </div>
    </div>

    <div v-else-if="!sessions.length" class="admin-card">
      <div class="admin-state admin-state--rich">
        <i class="fas fa-chart-line"></i>
        <h3>No games recorded yet</h3>
        <p>
          Play a game through to the end and your accuracy, timings and streaks
          will appear here so you can track how you improve.
        </p>
        <router-link to="/" class="admin-btn admin-btn--primary">
          Choose a department
        </router-link>
      </div>
    </div>

    <template v-else>
      <StatsSummary
        v-if="view === 'stats'"
        :sessions="sessions"
        :departments="departments"
      />
      <StatsCharts v-else :sessions="sessions" />
    </template>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { supabase } from '@/supabase';
import { fetchMySessions } from '@/services/statsService';
import StatsSummary from '@/components/stats/StatsSummary.vue';
import StatsCharts from '@/components/stats/StatsCharts.vue';
import StatsViewToggle from '@/components/stats/StatsViewToggle.vue';

const view = ref('stats');
const loading = ref(true);
const userId = ref(null);
const sessions = ref([]);
const departments = ref([]);

onMounted(async () => {
  try {
    const [{ userId: id, sessions: rows }, deptResult] = await Promise.all([
      fetchMySessions(),
      supabase.from('departments').select('id, name'),
    ]);

    userId.value = id;
    sessions.value = rows;
    departments.value = deptResult.data || [];
  } catch (error) {
    console.error('Could not load statistics:', error);
  } finally {
    loading.value = false;
  }
});
</script>
